import { Controller } from '@hotwired/stimulus';
import axios from "axios";
import {fadeInVisibility, fadeOutVisibility} from "../helpers";

export default class extends Controller {
    connect() {
        this.currentExpandedCard = null;
        this.faqContainer = this.element.querySelector('#faqContainer');
        this.topicSelector = this.element.querySelector('#faqTopicSelector');
        this.adminAjaxUrl = '/wp-admin/admin-ajax.php';
        this.loader = this.element.querySelector('.loader');
        this.currentTimeout = null;
        this.displayedPosts = this.element.dataset.displayedPosts;

        if (this.topicSelector) {
            this.topicSelector.addEventListener('change', () => {
                this.loadPosts(500, this.topicSelector.value);
            });
        }

        document.addEventListener('click', (event)=>{
            if (this.currentExpandedCard) {
                const answerContainer = event.currentTarget.querySelector('.faq-answer');
                if (!this.currentExpandedCard.contains(event.target)) {
                    this.currentExpandedCard.classList.remove('expanded');
                }
            }
        });
    }

    collapseCards(ignoredElement) {
        const expandedElements = this.element.querySelectorAll('.expanded');
        [...expandedElements].forEach(e => {
            if (ignoredElement !== e) {
                e.classList.remove('expanded');
            }
        });
    }

    toggleCard(e) {
        const answerContainer = e.currentTarget.querySelector('.faq-answer');
        if (answerContainer.contains(e.target)) {
            return;
        }
        this.collapseCards(e.currentTarget);
        e.currentTarget.classList.toggle('expanded');
        const topArrow = answerContainer.querySelector('.faq-answer__top');
        const bottomArrow =  answerContainer.querySelector('.faq-answer__bottom');

        if (e.currentTarget.classList.contains('expanded')) {
            this.currentExpandedCard = e.currentTarget;
            setTimeout(e=>{
                if (answerContainer.scrollHeight > answerContainer.clientHeight) {
                    fadeInVisibility(bottomArrow);
                }
                answerContainer.addEventListener('scroll', ()=>{this.scrollStuff(answerContainer, topArrow, bottomArrow)})
            }, 251) //1ms higher than transition delay
        } else {
            answerContainer.removeEventListener('scroll', ()=>{this.scrollStuff(answerContainer, topArrow, bottomArrow)})
        }
    }

    toggleRow(e) {
        const answerContainer = e.currentTarget.querySelector('.faq-answer');
        if (answerContainer.contains(e.target)) {
            return;
        }
        this.collapseCards(e.currentTarget);
        e.currentTarget.classList.toggle('expanded');
        const topArrow = answerContainer.querySelector('.faq-answer__top');
        const bottomArrow =  answerContainer.querySelector('.faq-answer__bottom');

        if (e.currentTarget.classList.contains('expanded')) {
            this.currentExpandedCard = e.currentTarget;
            setTimeout(e=>{
                if (answerContainer.scrollHeight > answerContainer.clientHeight) {
                    fadeInVisibility(bottomArrow);
                }
                answerContainer.addEventListener('scroll', ()=>{this.scrollStuff(answerContainer, topArrow, bottomArrow)})
            }, 251) //1ms higher than transition delay
        } else {
            answerContainer.removeEventListener('scroll', ()=>{this.scrollStuff(answerContainer, topArrow, bottomArrow)})
        }
    }

    scrollStuff(container, top, bottom) {
        const currentPos = container.scrollTop;
        const maxHeight = container.scrollHeight - container.clientHeight;
        if (currentPos > 25) {
            if (top.style.visibility !== 'visible') {
                fadeInVisibility(top);
            }
        } else {
            fadeOutVisibility(top);
        }
        if (currentPos > (maxHeight - 25)) {
            fadeOutVisibility(bottom)
        } else {
            if (bottom.style.visibility !== 'visible') {
                fadeInVisibility(bottom);
            }
        }

        return true;
    }



    loadPosts(delay, topic) {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = setTimeout(() => {
            this.faqContainer.innerHTML = '';
            this.loader.classList.remove('d-none');

            let formData = new FormData;
            formData.append('action', 'faq_load_posts');
            formData.append('perPage', this.displayedPosts);
            formData.append('topic', topic);

            axios.post(this.adminAjaxUrl, formData).then((response) => {
                if (response.data.html) {
                    this.loader.classList.add('d-none');
                    this.faqContainer.innerHTML += response.data.html;
                }
            });
        }, delay);
    }

    scrollUp(e) {
        const answerContainer = e.currentTarget.parentNode;
        answerContainer.scrollTop -= 50;
    }

    scrollDown(e) {
        const answerContainer = e.currentTarget.parentNode;
        answerContainer.scrollTop += 50;
    }
}
